import { getMonth, getYear } from 'date-fns-jalali';

export default function CalculateMonthsOnly(fromDate: Date, toDate: Date): number {
  const fromYear = getYear(fromDate); // سال تاریخ شروع
  const fromMonth = getMonth(fromDate) + 1; // ماه تاریخ شروع (شمسی)
  const toYear = getYear(toDate); // سال تاریخ پایان
  const toMonth = getMonth(toDate) + 1; // ماه تاریخ پایان (شمسی)

  let currentYear = fromYear;
  let currentMonth = fromMonth;

  let monthsCount = 0;

  while (currentYear < toYear || (currentYear === toYear && currentMonth <= toMonth)) {
    monthsCount++;

    // افزایش ماه و مدیریت انتقال به سال جدید
    currentMonth++;
    if (currentMonth > 12) {
      currentMonth = 1;
      currentYear++;
    }
  }

  return monthsCount;
}
